import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateHouseDetails = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    aboutHouse: "",
    typeOfHouse: "",
    permanentAddress: "",
    taluk: "",
    district: "",
    state: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      ...data,
    };

    api
      .post("/admin/userProfile/addressUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "House details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update house details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
       const d = res.data && res.data.data ? res.data.data : {};
        setData({
          aboutHouse: d.Profile.aboutHouse || "",
          typeOfHouse: d.Profile.typeOfHouse || "",
          permanentAddress: d.Profile.permanentAddress || "",
          taluk: d.Profile.taluk || "",
          district: d.Profile.district || "",
          state: d.Profile.state || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load house details", "error");
      });
  }, [id]);

  return (
    <div className="content mt-5">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title  mt-5">
            <div className="float-left">
              <h1 className="title">Update House  and Location Details</h1>
            </div>
          </div>

          <div className="col-12">
            <section className="box">
              <div className="content-body">
                <Form onSubmit={handleSubmit}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormGroup>
                      <Label>About House</Label>
                      <Input
                        type="text"
                        name="aboutHouse"
                        value={data.aboutHouse}
                        onChange={handleChange}
                        placeholder="Enter about house"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Type of House</Label>
                      <Input
                        type="text"
                        name="typeOfHouse"
                        value={data.typeOfHouse}
                        onChange={handleChange}
                        placeholder="Enter type of house"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Permanent Address</Label>
                      <Input
                        type="text"
                        name="permanentAddress"
                        value={data.permanentAddress}
                        onChange={handleChange}
                        placeholder="Enter permanent address"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Taluk</Label>
                      <Input
                        type="text"
                        name="taluk"
                        value={data.taluk}
                        onChange={handleChange}
                        placeholder="Enter taluk"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>District</Label>
                      <Input
                        type="text"
                        name="district"
                        value={data.district}
                        onChange={handleChange}
                        placeholder="Enter district"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>State</Label>
                      <Input
                        type="text"
                        name="state"
                        value={data.state}
                        onChange={handleChange}
                        placeholder="Enter state"
                      />
                    </FormGroup>

                    <Button style={{ background: "black", color: "white" }}>
                      Submit
                    </Button>
                  </Box>
                </Form>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpdateHouseDetails;
